var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "round-button__container" }, [
    _c(
      "button",
      {
        class: ["round-button__button", _vm.size],
        attrs: {
          type: "button",
          disabled: _vm.disabled,
          "data-test-id": _vm.testId
        },
        on: { click: _vm.handleClick }
      },
      [
        _c(
          "md-icon",
          {
            staticClass: "round-button__button-icon",
            attrs: {
              "md-src": _vm.iconSrc,
              "data-test-id": _vm.testId + "-icon"
            }
          },
          [_vm._v("\n      " + _vm._s(!_vm.iconSrc && _vm.icon) + "\n    ")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm.label
      ? _c(
          "span",
          {
            staticClass: "round-button__label",
            attrs: { "data-test-id": _vm.testId + "-label" }
          },
          [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38fc6772", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38fc6772","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/UI/RoundBtn.vue
// module id = V80v
// module chunks = 1